import React from "react";

import useResultData from "./ExamReviewComponents/useResultData";
import { DetailsProvider } from "./DetailsContext";
import MainResult from "./MainResult";


const TestAnalysis = () => {

  const { result, testSolutions, testSubjectsTopic, trackerId } =useResultData();

  return (
    <DetailsProvider>
      <MainResult
        result={result}
        testSolutions={testSolutions}
        testSubjectsTopic={testSubjectsTopic}
        trackerId={trackerId}
      />
    </DetailsProvider>
  );
};

export default TestAnalysis;
